<template>
  <div>
    <p>I am a lovely dummy boy but I am invisible so that you can not see me.What a pity!</p>
  </div>
</template>
<script>
export default {
  name: 'dummy'
}
</script>
